import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-review',
    templateUrl: './user-review.component.html',
    styleUrls: ['./user-review.component.css'],
    standalone: false
})
export class UserReviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
